/**
 * Возвращает объект с данными о текущем/заданом времени для указанного timeZone с учетом DST
 */
export default function getDateFormattedParts(
    timeZone: string,
    date = new Date(),
    locale = 'en-US',
    options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }
) {
    let formatter: Intl.DateTimeFormat;

    if (timeZone === 'Europe/Kyiv') {
        try {
            // Часовой пояс Europe/Kiev был переименовано на Europe/Kyiv в Августе 2022.
            // В не обновленных OS/браузерах может быть старый формат написания.
            formatter = new Intl.DateTimeFormat(locale, {
                timeZone: 'Europe/Kyiv',
                ...options
            });
        } catch (error) {
            console.warn(
                'Europe/Kyiv not recognized, falling back to Europe/Kiev',
                error
            );
            formatter = new Intl.DateTimeFormat(locale, {
                timeZone: 'Europe/Kiev',
                ...options
            });
        }
    } else
        formatter = new Intl.DateTimeFormat(locale, { timeZone, ...options });

    const parts = Object.fromEntries(
        formatter.formatToParts(date).map(p => [p.type, p.value])
    );

    return {
        year: +parts.year,
        month: +parts.month, // Отсчет от 1 до 12
        day: +parts.day,
        weekday: parts.weekday, // "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
        hours: +parts.hour,
        minutes: +parts.minute,
        seconds: +parts.second
    };
}
